import i18next from 'i18next'
// @ts-ignore
import { showSuccess } from 'store/entities/toastr/utils'

export const showMessageForUploadImages = (lengthOfFileList: number, errorsCounter: number ) => {
  if (lengthOfFileList > 1 && lengthOfFileList > errorsCounter + 1) {
    showSuccess({content: i18next.t('common:Images successfully uploaded')})
  }
  if ((lengthOfFileList > 1 && lengthOfFileList === errorsCounter + 1) || (lengthOfFileList === 1 && errorsCounter === 0)) {
    showSuccess({content: i18next.t('common:Image successfully uploaded')})
  }
}
